// SLIDER
const progressLine = document.querySelector('.inside-bar1');
var swiper = new Swiper(".mySwiper", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
            progressLine.style.setProperty("--progress", progress);
        }
    }

});

const progressLine2 = document.querySelector('.inside-bar2');
var swiper2 = new Swiper(".mySwiper2", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
            progressLine2.style.setProperty("--progress", progress);
        }
    }
});

const progressLine3 = document.querySelector('.inside-bar3');
var swiper2 = new Swiper(".mySwiper3", {
    effect: "fade",
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false
    },
    on: {
        autoplayTimeLeft(s, time, progress) {
            progressLine3.style.setProperty("--progress", progress);
        }
    }
});



